import { departmentList } from "constants/department";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const addDepartment = async (bodyData) => {
  try {
    const res = await API.add_department(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getDepartmentList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.department_list(pageNum, filters);
    dispatch({ type: departmentList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: departmentList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};

export const getDepartmentById = async (id) => {
  try {
    const res = await API.get_department_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateDepartmentById = async (id, bodyData) => {
  try {
    const res = await API.edit_department(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteDepartmentById = async (id) => {
  try {
    const res = await API.delete_department_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}